export enum Cloud {
  gcp = 'gcp',
  aws = 'aws',
  azure = 'azure',
  oracle = 'oracle',
  nebius = 'nebius',
  unknown = 'unknown', // BE might return unknown, so have to support it here as well.
}

export enum K8sProvider {
  EKS = 'eks',
  AKS = 'aks',
  GKE = 'gke',
  ROSA = 'openshift',
  KOPS = 'kops',
  ANYWHERE = 'anywhere',
  SELF_HOSTED = 'self_hosted_with_ec2_nodes',
  OKE = 'oke',
}

export const beCloudToCloud = (cloud: string | undefined): Cloud => {
  cloud = cloud?.toLowerCase();
  switch (cloud) {
    case 'aws':
      return Cloud.aws;
    case 'gcp':
      return Cloud.gcp;
    case 'azure':
      return Cloud.azure;
    case 'oracle':
      return Cloud.oracle;
    case 'nebius':
      return Cloud.nebius;
    default: {
      return Cloud.unknown;
    }
  }
};
